export default __webpack_public_path__ + "images/0x44e23b1f3f4511b3a7e81077fd9f2858df1b7579.png";